import { getGroupFilesHubFREStore } from '../store/GroupFilesHubFREStore';

export function shouldShowRecentCallout(): boolean {
    // We should show this callout if: shouldShowRecentFilesCallout is true, AND the Recent Files Callout has not been shown
    return (
        getGroupFilesHubFREStore().shouldShowRecentFilesCallout &&
        !getGroupFilesHubFREStore().recentFilesCalloutShown
    );
}
